import { ElementType } from 'react';
import { IconApproved, IconCross } from 'assets/img';

const payrollTaxStatuses = new Map<boolean, ElementType>([
  [true, IconApproved],
  [false, IconCross],
]);

export const getPayrollTaxStatusIcon = (isEnabled: boolean) => {
  return payrollTaxStatuses.get(isEnabled) || IconCross;
};
